import React, { useState, useEffect } from "react";
import { FaFacebook, FaInstagram,  FaStar, FaTwitter, FaTiktok, FaYoutube, FaMapMarkedAlt } from "react-icons/fa";



import { MdDeliveryDining, MdOutlineStorefront, MdPhone, MdExpandMore } from "react-icons/md";
import { FaLightbulb } from "react-icons/fa";
import "./info.css";
import { configShop } from '../../states/configShop';
import { apiGet } from '../../utils/api';
const RestaurantCard = () => {
  const { dataConfig } = configShop();
  const [openAccordion, setOpenAccordion] = useState({
    horarios: false,
    cobertura: false,
  });

  const [nData, setNData] = useState([]);
  useEffect(() => {
    (async function () {
      const res = await apiGet('/information');
      var mensajeExito = res.success;
      if (mensajeExito === "success") {
        setNData(res.data);
      }
    })();
    // }
  }, []);

  const toggleAccordion = (section) => {
    setOpenAccordion((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const horarios = [
    { dia: "Domingo", hora: "5:00 PM - 11:45 PM" },
    { dia: "Lunes", hora: "5:00 PM - 11:45 PM" },
    { dia: "Martes", hora: "5:00 PM - 11:45 PM", activo: true },
    { dia: "Miércoles", hora: "5:00 PM - Medianoche" },
    { dia: "Jueves", hora: "5:00 PM - 11:45 PM" },
    { dia: "Viernes", hora: "5:00 PM - Medianoche" },
    { dia: "Sábado", hora: "5:00 PM - Medianoche" },
  ];

  const zonas = [
    "SIMON BOLIVAR", "SANTA MARIA HOSPITAL", "VILLA SAN PEDRO 3", "HOTEL HOMERO",
    "SAN LUIS", "20 DE JULIO", "EL ROMANCE", "VILLA SAN CARLOS", "CALIFORNIA",
    "CLINICA ABATON (VIDA)", "CIRCUNVALAR", "VILLA SAN PEDRO 2", "CONIDE", "EL BOSQUE",
    "SANTO DOMINGO", "SIETE ABRIL", "VILLA SAN PEDRO 1", "LAS AMERICAS", "LAS GRANJAS"
  ];
  const abierto = true;
  return (
    <div className="card-container">
      <div className="card-header">
        <div>
          <div className={`estado ${abierto ? "abierto" : "cerrado"}`}>
            {abierto ? (
              <>
                <FaLightbulb className="text-warning bombillo-titilando me-1" />
                Abierto ahora
              </>
            ) : (
              "Cerrado por ahora"
            )}
          </div>
          <span className="delivery-time">{nData?.time_delivery}</span>
        </div>
        <img
          src={dataConfig?.company_logo}
          alt="Logo"
          className="img-fluid header-logo-2 mb-2"
          style={{ maxHeight: "60px" }}
        />
      </div>

      <h2 className="title">{dataConfig?.company_name}</h2>

      <div className="social-icons">
        <FaStar className="star" /> <span>{nData?.qualification}</span>
        {dataConfig?.social?.instragram && (

          <a
            href={`https://www.instagram.com/${dataConfig.social.instragram}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram color={dataConfig?.color_botton} size={20} className="mx-1" />
          </a>
        )}

        {dataConfig?.social?.facebook && (
          <a
            href={`https://www.facebook.com/${dataConfig.social.facebook}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook color={dataConfig?.color_botton} size={20} className="mx-1" />
          </a>
        )}

        {dataConfig?.social?.tiktok && (
          <a
            href={`https://www.tiktok.com/@${dataConfig.social.tiktok}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTiktok color={dataConfig?.color_botton} size={20} className="mx-1" />
          </a>
        )}

        {dataConfig?.social?.twiter && (
          <a
            href={`https://twitter.com/${dataConfig.social.twiter}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter color={dataConfig?.color_botton} size={20} className="mx-1" />
          </a>
        )}

        {dataConfig?.social?.youtube && (
          <a
            href={`https://www.youtube.com/${dataConfig.social.youtube}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube color={dataConfig?.color_botton} size={20} className="mx-1" />
          </a>
        )}
      </div>

      <div className="service-types">
        {nData?.services?.delivery && (
          <div className="service-option active">
            <MdDeliveryDining size={22} />
            <div>
              <p className="option-title">A domicilio</p>
              <p className="option-sub">Tiempo de entrega: {nData?.time_delivery}</p>
            </div>
          </div>
        )}
        {nData?.services?.order && (
          <div className="service-option">
            <MdOutlineStorefront size={22} />
            <div>
              <p className="option-title">Para llevar</p>
              <p className="option-sub">Retiro en tienda</p>
            </div>
          </div>
        )}


      </div>

      {/* Cobertura de entrega */}

      <div className="section">
        <div
          className="accordion-header"
          onClick={() => toggleAccordion("cobertura")}
        >
          <h4>Sedes</h4>
          <MdExpandMore
            className={`icon ${openAccordion.cobertura ? "rotate" : ""}`}
          />
        </div>
        <div
          className={`accordion-content ${openAccordion.cobertura ? "open" : ""
            }`}
        >
          {nData?.branch?.map((zona, i) => (
            <div key={i} className={`horario ${zona.status ? "active" : ""}`}>
              <span>{zona.name}</span>
              <span>
                <a
                  href={zona.point}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p className="boton-title-v3"><FaMapMarkedAlt color={dataConfig?.color_button_text} size={20} className="mx-1" /></p>
                </a>
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Horarios */}
      <div className="section">
        <div
          className="accordion-header"
          onClick={() => toggleAccordion("horarios")}
        >
          <h4>Horarios de atención</h4>
          <MdExpandMore
            className={`icon ${openAccordion.horarios ? "rotate" : ""}`}
          />
        </div>
        <div
          className={`accordion-content ${openAccordion.horarios ? "open" : ""
            }`}
        >
          {nData?.schedules?.map((h, i) => (
            <div key={i} className={`horario ${h.status ? "active" : ""}`}>
              <span>{h.day}</span>
              <span>{h.hour_open} - {h.hour_close}</span>
            </div>
          ))}
        </div>
      </div>
    </div >
  );
};

export default RestaurantCard;
